import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PeopleAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"people_alt"}/>
}
